<div #editor
  class="editor wrapper"
  >
  <placeholder-textarea [textModel]="textModel"
    [placeholder]="placeholder"
    (textChange)="onTextChanged($event)"
    >
  </placeholder-textarea>

  <div class="toolbar">
    @if (controls.alignment) {
      <text-alignment-chooser
        [alignment]="textModel.horizontalAlignment"
        (alignmentChange)="onAlignmentChanged($event)"
      ></text-alignment-chooser>
    }

    @if (controls.color) {
      <color-chooser
        [currentColor]="textModel.color"
        (currentColorChange)="onColorChanged($event)"
      ></color-chooser>
    }

    @if (controls.font) {
      <font-chooser
        [fontName]="fontName"
        (fontNameChange)="onFontNameChanged($event)"
      ></font-chooser>
    }

    @if (controls.fontSize) {
      <text-size-chooser #sizeChooser
        [fontSize]="textModel.fontSize"
        [minFontSize]="minFontSize"
        (fontSizeChange)="onFontSizeChanged($event)"
        [enabled]="!isTextEmpty"
      ></text-size-chooser>
    }
  </div>

  <div class="buttons">
    <button mat-raised-button translate
      size="small"
      (click)="onCancelClicked()">
    i18n.button.cancel
  </button>
  <button mat-raised-button color="primary" translate
    size="small"
    (click)="onApplyClicked()">
    i18n.button.apply
  </button>
</div>

</div>
